import { useQuery } from '@tanstack/vue-query'
import { getApi } from "./api";
export default (accountId: number, search=null) => useQuery({
    queryKey: ['account-dialogs', accountId, search ? search.value : ''],
    queryFn: () => {
        const { api, baseURL } = getApi();
        const params = search && search.value ? { search: search.value } : {};
        return api.get(`api/v2/accounts/${accountId}/dialogs`, { 
          baseURL,
          params,
          useOriginalToken: true
        }).then( res => res.data.data );
    },
})
